import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Layout from '../Componets/Layout';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function EditClient() {
  const apiUrl = process.env.REACT_APP_API_URL; // Get the API URL from the .env file
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const [value, setValue] = useState({
    name: '',
    email: '',
    address: '',
    city: '',
    pincode: '',
    contactPerson: '',
    contactNo: '',
    website: '',
    registrationDate: '',
    remarks: '',
    isTwoFactorAuthentication: false,
    otpVerification: 'Email', // Default value for otpVerificatio
    storage: '',
    isownAWS: false,
    accessKey: '',
    secretAccessKey: '',
    bucketName: '',
    bucketRegion: '',
    bucketUrl: '',
  });
  const focusInputRef = useRef(null); // Ref for the username input
  const currentPath = location?.pathname || '';

  // Super admin only page access
  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'SUPER_ADMIN') {
      navigate('/');
    }
    focus();
  }, [navigate]);
  const focus = () => {
    if (focusInputRef.current) {
      focusInputRef.current.focus();
    }
  };

  // Fetch the client details on component mount
  useEffect(() => {
    const token = localStorage.getItem('token');
    axios
      .get(`${apiUrl}/api/client/${id}`, {
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        const clientData = res?.data?.client || {};
        const settingData = res?.data?.setting || {};
        const AwsDetail = res?.data?.awsDetail || {};

        setValue({
          name: clientData.name || '',
          email: clientData.email || '',
          address: clientData.address || '',
          city: clientData.city || '',
          pincode: parseInt(clientData.pincode, 10) || '',
          contactPerson: clientData.contactPerson || '',
          contactNo: clientData.contactNo || '',
          website: clientData.website || '',
          registrationDate: clientData.registrationDate || '',
          remarks: clientData.remarks || '',
          isTwoFactorAuthentication:
            settingData?.isTwoFactorAuthentication || false,
          otpVerification: settingData?.otpVerification || 'Email',
          storage: settingData?.storage || '',
          isownAWS: settingData?.isownAWS || false,
          accessKey: AwsDetail?.accessKey || '',
          secretAccessKey: AwsDetail?.secretAccessKey || '',
          bucketName: AwsDetail?.bucketName || '',
          bucketRegion: AwsDetail?.bucketRegion || '',
          bucketUrl: AwsDetail?.bucketUrl || '',
        });
      })
      .catch((err) => {
        console.error(err);
        err.response?.status === 401 && navigate('/');
      });
  }, [id, apiUrl]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    const confirmUpdate = window.confirm(
      'Are you sure you want to update the client?'
    );
    if (!confirmUpdate) return; // Exit if user cancels

    // Clone formData to avoid mutating original state
    let filteredData = { ...value };

    // Remove AWS fields if isownAWS is false
    if (!filteredData.isownAWS && filteredData.isownAWS === false) {
      delete filteredData.accessKey;
      delete filteredData.secretAccessKey;
      delete filteredData.bucketName;
      delete filteredData.bucketRegion;
      delete filteredData.bucketUrl;
    }

    axios
      .put(
        `${apiUrl}/api/client/${id}`,
        {
          ...filteredData,
          pincode: parseInt(filteredData.pincode, 10), // Convert pincode to number
        },
        {
          headers: {
            Authorization: token,
          },
        }
      )
      .then((res) => {
        toast.success('Client updated successfully');

        if (currentPath === '/EditClinet') {
          const timeOutDuration = 3000;
          const timeoutId = setTimeout(() => {
            if (window.location.pathname === '/EditClinet') {
              navigate(-1);
            }
          }, timeOutDuration);
          return () => clearTimeout(timeoutId);
        }
        focus(); // Focus on the username input after successful update
      })
      .catch((err) => {
        console.error(err);
        err.response?.status === 401 && navigate('/');
        toast.error(err.response?.data?.message || 'An error occurred');
      });
  };

  // Toggle two-factor authentication
  const handleSwitchChange = () => {
    setValue((prevState) => ({
      ...prevState,
      isTwoFactorAuthentication: !prevState.isTwoFactorAuthentication,
      // Set otpVerification to 'Email' when enabling two-factor authentication
      otpVerification: !prevState.isTwoFactorAuthentication
        ? 'Email'
        : prevState.otpVerification,
    }));
  };

  // Handle OTP verification method change
  const handleRadioChange = (e) => {
    setValue((prevState) => ({
      ...prevState,
      otpVerification: e.target.value,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValue((prevState) => ({
      ...prevState,
      [name]: name === 'pincode' ? parseInt(value) || '' : value,
    }));
  };

  const handleStorageTypeChange = (e) => {
    const value = e.target.value;

    setValue((prev) => ({
      ...prev,
      storage: value,
      isownAWS: false,
    }));
  };

  const handleAWSOwnerChange = (e) => {
    const { value } = e.target;
    setValue((prev) => ({
      ...prev,
      isownAWS: value === 'true', // convert string to boolean
    }));
  };

  return (
    <Layout ac2="active">
      <main id="main" className="main">
        <div className="pagetitle mb-4">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/Home">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">
                <Link to="/ViewClient">View Clients</Link>
              </li>
              <li className="breadcrumb-item active">Edit Client</li>
            </ol>
          </nav>
        </div>
        <section className="section col-lg-12">
          <div className="row">
            <div className="">
              <div className="card">
                <div className="card-body mt-5 mb-1 mx-3">
                  <form onSubmit={handleSubmit}>
                    {/* Client details */}
                    {/* (All form fields before Two-factor Authentication section remain the same) */}
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-floating mb-2">
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Name"
                            value={value.name}
                            onChange={(e) =>
                              setValue({ ...value, name: e.target.value })
                            }
                            ref={focusInputRef}
                          />
                          <label className="form-label" htmlFor="txtGrNo">
                            Name <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm">
                        <div className="form-floating mb-2">
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Name"
                            value={value.address}
                            onChange={(e) =>
                              setValue({ ...value, address: e.target.value })
                            }
                          />
                          <label className="form-label" htmlFor="txtGrNo">
                            Address <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                      <div className="col-sm">
                        <div className="form-floating mb-2">
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Name"
                            value={value.city}
                            onChange={(e) =>
                              setValue({ ...value, city: e.target.value })
                            }
                          />
                          <label className="form-label" htmlFor="txtGrNo">
                            City <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                      <div className="col-sm">
                        <div className="form-floating mb-2">
                          <input
                            className="form-control"
                            type="number"
                            placeholder="Name"
                            value={value.pincode}
                            onChange={(e) =>
                              setValue({ ...value, pincode: e.target.value })
                            }
                            onWheel={(e) => e.target.blur()}
                          />
                          <label className="form-label" htmlFor="txtGrNo">
                            Pin code <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col">
                        <div className="form-floating mb-2">
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Name"
                            value={value.contactPerson}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                contactPerson: e.target.value,
                              })
                            }
                          />
                          <label className="form-label" htmlFor="txtGrNo">
                            Contect Person{' '}
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-floating mb-2">
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Name"
                            value={value.contactNo}
                            onChange={(e) =>
                              setValue({ ...value, contactNo: e.target.value })
                            }
                          />
                          <label className="form-label" htmlFor="txtGrNo">
                            Contect Number{' '}
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                      <div className="w-100"></div>
                      <div className="col">
                        <div className="form-floating mb-2">
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Name"
                            value={value.email}
                            onChange={(e) =>
                              setValue({ ...value, email: e.target.value })
                            }
                          />
                          <label className="form-label" htmlFor="txtGrNo">
                            Email<span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-floating mb-2">
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Name"
                            value={value.website}
                            onChange={(e) =>
                              setValue({ ...value, website: e.target.value })
                            }
                          />
                          <label className="form-label" htmlFor="txtGrNo">
                            Website{' '}
                          </label>
                        </div>
                      </div>
                      <div className="w-100"></div>
                      <div className="col">
                        <div className="form-floating mb-2">
                          <input
                            className="form-control"
                            type="date"
                            data-date=""
                            data-date-format="YYYY MM DD"
                            placeholder="Name"
                            value={value.registrationDate}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                registrationDate: e.target.value,
                              })
                            }
                          />
                          <label className="form-label" htmlFor="txtGrNo">
                            Registration Date{' '}
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-floating mb-2">
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Name"
                            value={value.remarks}
                            onChange={(e) =>
                              setValue({ ...value, remarks: e.target.value })
                            }
                          />
                          <label className="form-label" htmlFor="txtGrNo">
                            Remarks
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Storage Type */}
                    <div className="row">
                      <div className="col">
                        <div className="form-floating mb-2">
                          <select
                            className="form-select"
                            name="storage"
                            value={value.storage}
                            onChange={handleStorageTypeChange}
                            required
                          >
                            <option value="">Select Type of Storage </option>
                            <option value="InternalStorage">Local</option>
                            <option value="Aws">AWS</option>
                          </select>
                          <label htmlFor="storage">
                            Storage Type <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Only show this when AWS is selected */}
                    {value.storage === 'Aws' && (
                      <div className="row">
                        <div className="col">
                          <div className="form-floating mb-2">
                            <select
                              className="form-select"
                              name="isownAWS"
                              value={value.isownAWS.toString()} // bind value correctly
                              onChange={handleAWSOwnerChange}
                              required
                            >
                              <option value="">Select Type of Aws</option>
                              <option value="false">Printf</option>
                              <option value="true">Client</option>
                            </select>

                            <label htmlFor="isownAWS">
                              AWS Owner <span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                    {value.storage === 'Aws' && value.isownAWS === true && (
                      <>
                        <div className="row">
                          <div className="col">
                            <div className="form-floating mb-2">
                              <input
                                className="form-control"
                                type="text"
                                name="accessKey"
                                value={value.accessKey}
                                onChange={handleChange}
                                placeholder="Access Key"
                                required
                              />
                              <label>
                                Access Key{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                          <div className="col">
                            <div className="form-floating mb-2">
                              <input
                                className="form-control"
                                type="text"
                                name="secretAccessKey"
                                value={value.secretAccessKey}
                                onChange={handleChange}
                                placeholder="Secret Access Key"
                                required
                              />
                              <label>
                                Secret Access Key{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col">
                            <div className="form-floating mb-2">
                              <input
                                className="form-control"
                                type="text"
                                name="bucketName"
                                value={value.bucketName}
                                onChange={handleChange}
                                placeholder="Bucket Name"
                                required
                              />
                              <label>
                                Bucket Name{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                          <div className="col">
                            <div className="form-floating mb-2">
                              <input
                                className="form-control"
                                type="text"
                                name="bucketRegion"
                                value={value.bucketRegion}
                                onChange={handleChange}
                                placeholder="Bucket Region"
                                required
                              />
                              <label>
                                Bucket Region{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col">
                            <div className="form-floating mb-2">
                              <input
                                className="form-control"
                                type="text"
                                name="bucketUrl"
                                value={value.bucketUrl}
                                onChange={handleChange}
                                placeholder="Bucket URL"
                                required
                              />
                              <label>
                                Bucket URL{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {/* Two-factor authentication and OTP verification */}
                    <div className="row">
                      <div className="d-flex flex-row">
                        <div className="mt-1 px-2">Authentication</div>
                        <div className="mx-2">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input border-dark"
                              type="checkbox"
                              id="isTwoFactorAuthentication"
                              checked={value.isTwoFactorAuthentication}
                              onChange={handleSwitchChange}
                              style={{ height: '24px', width: '55px' }}
                            />
                          </div>
                        </div>

                        {value.isTwoFactorAuthentication && (
                          <div className="mx-2 mt-1">
                            <div className="d-flex flex-row">
                              <div className="px-2">
                                <label> Method:</label>
                              </div>
                              <div className="mx-2">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    id="otpEmail"
                                    name="otpVerification"
                                    value="Email"
                                    checked={value.otpVerification === 'Email'}
                                    onChange={handleRadioChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="otpEmail"
                                  >
                                    Email
                                  </label>
                                </div>
                              </div>
                              <div className="">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    id="otpPhone"
                                    name="otpVerification"
                                    value="SMS"
                                    checked={value.otpVerification === 'SMS'}
                                    onChange={handleRadioChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="otpPhone"
                                  >
                                    SMS
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Form buttons */}
                    <div className="row mb-3">
                      <div className="col-sm-12 pt-4 text-end">
                        <button
                          type="button"
                          className="btn btn-primary px-3"
                          onClick={() => navigate(-1)}
                        >
                          <i className="bi bi-arrow-bar-left"></i>Back
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary  px-4 mx-2"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <ToastContainer position="top-center" style={{ width: 'auto' }} />
    </Layout>
  );
}
